module.exports = __webpack_public_path__ + "static/media/chart.6b89bd82.svg";